<template>
  <div class="duration-wrapper">
    <div class="checkbox-row">
      <v-range-slider
        max="18"
        min="0"
        thumb-color="#33bbff"
        color="#33bbff"
        track-color="white"
        track-fill-color="#33BBFF75"
        @input="onChangeRange($event)"
        :value="value"
        :readonly="readonly"
      ></v-range-slider>
    </div>
    <div class="input-values">
      <div class="">
        <input
          class="number-input"
          :value="value[0]"
          v-on:blur="changeRange($event, 0)"
        />
      </div>
      <div class="">
        <input
          class="number-input"
          :value="value[1]"
          v-on:blur="changeRange($event, 1)"
          :readonly="readonly"
        />
        <!-- <input
          v-if="value[1] > 18"
          :readonly="readonly"
          class="number-input"
          type="text"
          value="∞"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "readonly"],
  data() {
    return {
      range: [5, 10],
    };
  },
  methods: {
    changeRange(e, i) {
      let tmp;
      if (i === 0) {
        tmp = [parseInt(e.srcElement.value), this.range[1]];
      } else {
        tmp = [this.range[0], parseInt(e.srcElement.value)];
      }
      this.range = tmp;

      this.$emit("input", tmp);
    },

    onChange(values) {
      this.$emit("input", values);
    },
    onChangeRange(values) {
      this.range = values;
      this.$emit("input", values);
    },
    checkIfActive(e, value) {
      if (this.checked == null) {
        e.preventDefault();
      }
    },
  },
  mounted() {},
  computed: {
    maxAge: function (age) {
      return age > 18 ? 0 : age;
    },
  },
};
</script>

<style>
</style>
